import { RAISON_DEMANDE } from '../model';

export default factory;

function factory() {
  return (value) => {
    switch (value) {
      case RAISON_DEMANDE.DEFAUT_RECEPTION:
        return 'Défaut de réception de la TNT';
      case RAISON_DEMANDE.DEMANDE_AIDE:
        return 'Demande d\'aide à la réception ou demande de remboursement de travaux éligibles sur facture';
      default:
        return '';
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/accueil/filters/raison-demande.filter.js